export default __webpack_public_path__ + "static/media/how-it-works-4.759991e4.png";